const mapTilerStyle = process.env.REACT_APP_MAPTILER_STYLE || 'streets';

const key = process.env.REACT_APP_MAPTILER_KEY || '';

const buildDefaultUrl = () => {
  if (!key) {
    console.warn('MapTiler key is missing. Falling back to OSM.');
    return 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  }

  return `https://api.maptiler.com/maps/${mapTilerStyle}/{z}/{x}/{y}.png?key=${key}`;
};

export const MAP_TILE_URL =
  process.env.REACT_APP_MAP_TILE_URL || buildDefaultUrl();

export const MAP_TILE_ATTRIBUTION =
  process.env.REACT_APP_MAP_TILE_ATTRIBUTION ||
  '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener noreferrer">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap contributors</a>';